import React from 'react';
import Button from '../../../components/ui/Button';


const StepNavigation = ({ 
  currentStep, 
  totalSteps, 
  onNext, 
  onPrevious, 
  onCancel,
  onSaveDraft,
  onSaveAndExit,
  isNextDisabled = false,
  isLoading = false,
  isSavingDraft = false,
  nextButtonText = 'Next',
  showCancel = true
}) => {
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;

  if (isLastStep) {
    return (
      <div className="pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {showCancel && (
              <Button
                variant="ghost"
                onClick={onCancel}
                disabled={isLoading || isSavingDraft}
              >
                Cancel
              </Button>
            )}
            {!isFirstStep && (
              <Button
                variant="outline"
                onClick={onPrevious}
                disabled={isLoading || isSavingDraft}
                iconName="ChevronLeft"
                iconPosition="left"
              >
                Previous
              </Button>
            )}
          </div>

          <div className="flex items-center space-x-3">
            <Button
              variant="outline"
              onClick={onSaveDraft}
              disabled={isLoading || isSavingDraft}
              loading={isSavingDraft}
              iconName="Save"
              iconPosition="left"
              size="sm"
            >
              Save Draft
            </Button>
            <Button
              variant="ghost"
              onClick={onSaveAndExit}
              disabled={isLoading || isSavingDraft}
              iconName="FolderOpen"
              iconPosition="left"
              size="sm"
            >
              Save & Exit
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between pt-6 border-t border-border">
      {/* Left Side - Cancel/Previous */}
      <div className="flex items-center space-x-3">
        {showCancel && (
          <Button
            variant="ghost"
            onClick={onCancel}
            disabled={isLoading || isSavingDraft}
          >
            Cancel
          </Button>
        )}
        
        {!isFirstStep && (
          <Button
            variant="outline"
            onClick={onPrevious}
            disabled={isLoading || isSavingDraft}
            iconName="ChevronLeft"
            iconPosition="left"
          >
            Previous
          </Button>
        )}
      </div>

      {/* Center - Draft Actions */}
      <div className="flex items-center space-x-2">
        <Button
          variant="outline"
          onClick={onSaveDraft}
          disabled={isLoading || isSavingDraft}
          loading={isSavingDraft}
          iconName="Save"
          iconPosition="left"
          size="sm"
        >
          Save Draft
        </Button>
        
        <Button
          variant="ghost"
          onClick={onSaveAndExit}
          disabled={isLoading || isSavingDraft}
          iconName="FolderOpen"
          iconPosition="left"
          size="sm"
        >
          Save & Exit
        </Button>
      </div>

      {/* Right Side - Next/Complete */}
      <div className="flex items-center space-x-3">
        <Button
          variant="default"
          onClick={onNext}
          disabled={isNextDisabled || isLoading || isSavingDraft}
          loading={isLoading}
          iconName="ChevronRight"
          iconPosition="right"
        >
          {nextButtonText}
        </Button>
      </div>
    </div>
  );
};

export default StepNavigation;